import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

class VoyageSummarySvc {
  constructor() {
    this.api = axiosInstance.create({
      baseURL: process.env.VUE_APP_API_URL,
    });
  }

  // Satu request, summary langsung jadi.
  async fetchById(mvygId) {
    try {
      const res = await this.api.get(`/voyage/summary/${mvygId}`, {
        cancelToken: getNewCancelToken(),
      });
      const { status, data } = res.data;

      // Gagal dibalikin HTTP 200 + envelope error, bukan lewat catch axios.
      if (status?.error) {
        throw Object.assign(
          new Error(status.message || 'Failed to fetch voyage summary'),
          { errorCode: status.errorCode },
        );
      }

      return data.summary;
    } catch (err) {
      return Promise.reject(err);
    }
  }
}

export default new VoyageSummarySvc();
